import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export interface DefaultAvatarProps extends SvgIconProps {
  readonly fillColor?: string
}
const DefaultAvatar = forwardRef<SVGSVGElement, DefaultAvatarProps>(
  function DefaultAvatar({ fillColor = '#9F9B9B', ...rest }, ref) {
    return (
      <SvgIcon ref={ref} {...rest}>
        <path
          d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
          fill={fillColor}
        />
      </SvgIcon>
    )
  },
)

export default DefaultAvatar
